// src/stone/illustrations/StonjiCreditCardFrontIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiCreditCardFrontIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 80 80",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "#00A868", d: "M80.5 0H.5v80h80z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M59.69 5.001H21.31a5.79 5.79 0 0 0-5.79 5.791v58.416a5.79 5.79 0 0 0 5.79 5.79h38.38a5.79 5.79 0 0 0 5.79-5.79V10.792a5.79 5.79 0 0 0-5.79-5.79"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#20252A",
          d: "M20.505 14.973a4.986 4.986 0 1 0 0-9.972 4.986 4.986 0 0 0 0 9.972M60.495 14.973a4.986 4.986 0 1 0 0-9.972 4.986 4.986 0 0 0 0 9.972M20.505 74.999a4.986 4.986 0 1 0 0-9.972 4.986 4.986 0 0 0 0 9.972M60.495 74.999a4.986 4.986 0 1 0 0-9.972 4.986 4.986 0 0 0 0 9.972"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M49.249 64.996a2.498 2.498 0 1 0 0-4.996 2.498 2.498 0 0 0 0 4.996M49.249 40a2.498 2.498 0 1 0 0-4.996 2.498 2.498 0 0 0 0 4.996"
        }
      ),
      /* @__PURE__ */ jsx("path", { fill: "#fff", d: "M46.756 62.498h5V37.502h-5z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M31.741 27.5a2.498 2.498 0 1 0 0-4.997 2.498 2.498 0 0 0 0 4.996"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M36.743 27.5a2.498 2.498 0 1 0 0-4.997 2.498 2.498 0 0 0 0 4.996M31.741 20a2.498 2.498 0 1 0 0-4.996 2.498 2.498 0 0 0 0 4.996"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M36.743 20a2.498 2.498 0 1 0 0-4.996 2.498 2.498 0 0 0 0 4.996"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M32.046 27.5h4.407a2.79 2.79 0 0 0 2.793-2.793v-6.916a2.79 2.79 0 0 0-2.793-2.792h-4.407a2.79 2.79 0 0 0-2.793 2.792v6.916a2.79 2.79 0 0 0 2.793 2.792"
        }
      )
    ]
  }
);
var StonjiCreditCardFrontIllustration_default = StonjiCreditCardFrontIllustration;

export {
  StonjiCreditCardFrontIllustration_default
};
